module.exports = __webpack_public_path__ + "img/00.40decda8.png";